/** The ink every line, stop and plaque of the metro map is outlined with. */
export const METRO_INK = '#1B2A4A';

/** Bonus spurs and bonus stops; kept apart from every line colour. */
export const METRO_SPUR = '#7A5AF8';

export const METRO_PAPER = '#FFFDF8';

const LINE_COLORS = [ '#3D7BEA', '#FF6B4A', '#2A9D8F', '#E9A23B', '#D9488B', '#4C5FD5', '#2BA84A', '#9A6B4F', '#00A3C4', '#7C8798' ];

/** The colour of the line a lesson group is drawn as; they repeat after ten groups. */
export function lineColor(unitIndex: number): string {
    return LINE_COLORS[unitIndex % LINE_COLORS.length];
}

/** The washed-out tone of a line the user has not travelled yet. */
export function paleColor(hex: string): string {
    const value = parseInt(hex.slice(1), 16);
    const channel = (shift: number) => Math.round(((value >> shift) & 255) * 0.32 + 255 * 0.68);

    return '#' + [ 16, 8, 0 ].map((shift) => channel(shift).toString(16).padStart(2, '0')).join('');
}
